import { Switch as BaseSwitch, styled, SwitchProps } from '@mui/material'

export const Switch = styled((props: SwitchProps) => (
  <BaseSwitch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 52,
  height: 32,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: '8px 6px',
    transitionDuration: '300ms',
    '&.Mui-checked': {
      margin: 4,
      transform: 'translateX(20px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#DE2826',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
      '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 24,
        height: 24,
        color: '#fff',
        boxShadow:
          '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
      },
    },
    '&.Mui-focusVisible .MuiSwitch-track': {
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      border: `2px solid ${theme.palette.grey[100]}`,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 16,
    height: 16,
    color: '#BCBCBC',
    boxShadow: 'none',
  },
  '& .MuiSwitch-track': {
    borderRadius: 100,
    backgroundColor: '#E3E2E2',
    border: '2px solid #BCBCBC',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))
